import getLocalStorage from "./getLocalStorage";

const saveLocalStorageItem = (key: string, value: unknown) => {
  const storage = getLocalStorage();
  if (!storage) {
    return;
  }

  storage.setItem(key, JSON.stringify(value));
};

export default saveLocalStorageItem;
